import React, { useState, useRef, useEffect, useContext, use } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/Style.css";
import MenuIcon from "../assets/images/icons/Menu.svg";
import settingsgrey from "../assets/images/icons/settings-blue.svg";
import Setting from "../pages/Cigna/setting";
import "../styles/utility.css";
import { useNavigate } from "react-router-dom";
import { GetPayLoad, RemovePayLoad } from "../services/PayLoadStorage";
import { LanguageContext, useLanguage } from "../contexts/LanguageContext";
import Cookies from "js-cookie";
import GPPBanner from "./GPPBanner"; //GPP Banner - st67393
import { getApiService } from "../services/ApiService";
//import { useCaseInfo } from "../contexts/CaseInfoContext";

// Q5 Carrier Mobile Customization Constants
const MOBILE_BREAKPOINT = 767; // Max width for mobile phones (excludes tablets)
const Q5_CARRIER_CODE = "Q5";


const Header = ({ headerName, onMobileSidebarToggle, isMobileSidebarOpen, caseInfo }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const menuContainerRef = useRef(null);
  const { pageContent } = useContext(LanguageContext);
  const [genericContent, setGenericContent] = useState([]);

  const stateCode = sessionStorage.getItem('stateCode') || '';
  // Toggle dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    switchTheme();
    if (pageContent?.generic) {
      setGenericContent(pageContent.generic);
    }

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pageContent]);

  const { toggleLanguage, language } = useLanguage();

  const Payload = GetPayLoad("PayLoad");
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState(null);
  
  // Q5 Carrier Detection
  const owningCarrier = Cookies.get("owningCarrier");
  const isQ5Carrier = owningCarrier === Q5_CARRIER_CODE;
  
  // Mobile View Detection (phones only, excludes tablets)
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  
  // Q5 Mobile Specific Behavior Flag
  const isQ5Mobile = isQ5Carrier && isMobileView;
  
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(isQ5Mobile);
  
  const toggleMobileMenu = () => {
    // Q5 mobile menu is always visible, don't toggle
    if (!isQ5Mobile) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    }
  };
  
  // Handle window resize for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobileView(isMobile);
      
      // Q5: Force menu open on mobile, close on larger screens
      if (isQ5Carrier && isMobile) {
        setIsMobileMenuOpen(true);
      } else if (!isMobile) {
        setIsMobileMenuOpen(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isQ5Carrier]);
  const obj = {
    id: 5,
    icon: "fe-settings-r icon",
    src: settingsgrey,
    name: "Setting",
    title: "Account Settings",
    component: <Setting />,
  };
  const [anchorProfile, setAnchorProfile] = useState(null);
  const open = Boolean(anchor);
  const openProfile = Boolean(anchorProfile);
  const [anchorLanguage, setAnchorLanguage] = useState(null);
  const openLanguage = Boolean(anchorLanguage);
  const currentLang = Cookies.get("lang") || "eng";
  const [logoSrc, setLogoSrc] = useState("");
  const [profileSrc, setProfileSrc] = useState("");
  const [privacyLink, setPrivacyLink] = useState('');
  const [feedbackDisplay, setFeedbackDisplay] = useState('');
  const [stateFaqCheck, setStateFaqCheck] = useState(false);
  const [stateFaqList, setStateFaqList] = useState([]);
  //const { caseInfo } = useCaseInfo();


  const isConnectiCareCarrier = Cookies.get("isConnectiCareCarrier") || 'false';
  const connectiCareCarrier = Cookies.get("connectiCareCarrier") || null;

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const headers = {
      "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
      "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
      "X-Hps-Region": Payload?.region ?? Cookies.get("region") ?? "",
      "X-Hps-Carrier": Payload?.owning_carrier  ?? Cookies.get("owningCarrier") ?? ""
  };
  
  const switchTheme = async () => {
    
    let owningCarrier = Cookies.get("owningCarrier");
    
    if(isConnectiCareCarrier === 'true' && connectiCareCarrier !== null && connectiCareCarrier !== undefined){
      owningCarrier = connectiCareCarrier;
    }
    
    import("../assets/images/carriers-logo/" + owningCarrier + "-sml.svg").then(
      (image) => {
        setLogoSrc(image.default);
      }
    );

    import("../assets/images/carriers-logo/Profile-" + owningCarrier + ".svg").then(
      (image) => {
        setProfileSrc(image.default);
      }).catch((error) => {
        import("../assets/images/carriers-logo/Profile.svg").then((image) => {
          setProfileSrc(image.default);
        });
    });

    if (owningCarrier === "CG") {
      await import("../assets/css/J1.css");
    }
    await import("../assets/css/" + owningCarrier + ".css");
  };

  const handleNotification = (event) => {
    setAnchor(event.currentTarget);
  };
  const handleLanguage = (event) => {
    //setAnchorLanguage(event.currentTarget);
    //if (event.currentTarget.id === "langOption") {
    //  toggleLanguage(currentLang === "eng" ? "spa" : "eng");
    //}
    setAnchorLanguage(event.target.value);
    toggleLanguage(event.target.value);
  };
  const handleProfile = (event) => {
    setAnchorProfile(event.currentTarget);
  };
  const handleClose = () => {
    setAnchor(null);
    setAnchorProfile(null);
    setAnchorLanguage(null);
  };
  const handleAccountSettings = () => {
    setIsDropdownOpen(false);
    navigate("/settings");
  };
  const [menuToggle, setMenuToggle] = useState(false);
  const handleMenu = () => {
    setMenuToggle(prev => !prev);
  };
  const handleMenuToggle = () => {
    setMenuToggle(!menuToggle);
  };

  const handleKeyDown = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  const handleLogout = () => {
    //toast.success('You are logged out successfully!.');
    setIsDropdownOpen(false);
    RemovePayLoad("PayLoad");
    window.location.href = "/logout";
    
  };

  useEffect(() => {
    const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
    getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'PRIVACY_LINK', carrierCode: isConnectiCareCarrier === 'true' ? connectiCareCarrier : Payload?.owning_carrier ?? Cookies.get("owningCarrier") }, headers)
        .then((response) => {
            if (response?.data?.statusCode === 200) {
                const result = response.data.data;
                setPrivacyLink(result);
            }
        })
        .catch(error => {
            console.log("Get rule value API Failure");
        });
    getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'CIGNA_FEEDBACK_LINK_DISPLAY', carrierCode: Cookies.get("owningCarrier") }, headers)
        .then((response) => {
            if (response?.data?.statusCode === 200) {
                const result = response.data.data;
                console.log("CIGNA_FEEDBACK_LINK_DISPLAY: ", result);
                setFeedbackDisplay(result);
            }
        })
        .catch(error => {
            console.log("Get rule value API Failure");
        });
  }, []);

  const [cignaFaqLink, setCignaFaqLink] = useState(false);

  //st48236 - using for FAQ url checking
  useEffect(() => {
    const carrier = Cookies.get("owningCarrier");
    if (!carrier) {
      return;
    }
    
    const isUsaaFaq = caseInfo?.isUSAAFaq === true || Cookies.get('isUsaaFaq') === 'true';
    const isNonUsaaFaq = caseInfo?.isNonUSAAFaq === true || Cookies.get('isNonUsAAFaq') === 'true';

    const targetRuleValueUrl = process.env.REACT_APP_API_GET_PROGRAM_RULE_VALUE_ENDPOINT;
    // This is only for Cigna FAQ Link
    if (isUsaaFaq) {
      getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_LINK_USAA', carrierCode: carrier }, headers)
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            const result = response.data.data;
            setCignaFaqLink(result);
          }
        })
        .catch(error => {
          console.log("Get FAQ state list rule value API Failure");
        });
    } else if (isNonUsaaFaq) {
      getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_LINK', carrierCode: carrier }, headers)
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            const result = response.data.data;
            setCignaFaqLink(result);
          }
        })
        .catch(error => {
          console.log("Get FAQ non USAA link rule value API Failure");
        });
    }

    getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_STATE_BASED_CHECK', carrierCode: carrier }, headers)
        .then((response) => {
            if (response?.data?.statusCode === 200) {
                const result = response.data.data;
                setStateFaqCheck(result);
            }
        })
        .catch(error => {
            console.log("Get FQA state check rule value API Failure");
        });
    getApiService(baseUrl, targetRuleValueUrl, { action: 'ByRule', rulename: 'FAQ_STATE_LIST', carrierCode: carrier }, headers)
        .then((response) => {
            if (response?.data?.statusCode === 200) {
                const result = response.data.data;
                setStateFaqList(result);
            }
        })
        .catch(error => {
            console.log("Get FAQ state list rule value API Failure");
        });

  }, [caseInfo?.isUSAAFaq, caseInfo?.isNonUSAAFaq]);
    
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuToggle &&
        menuContainerRef.current &&
        !menuContainerRef.current.contains(event.target)
      ) {
        const menuButton = document.querySelector('[aria-label="Open menu"]');
        if (!menuButton?.contains(event.target)) {
          setMenuToggle(false);
        }
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuToggle]);

  // Set FAQ URL based on carrier and state, with special handling for ConnectiCare carriers to point to their FAQ page instead of state-specific FAQs
  const [faqUrl, setFaqUrl] = useState('');
  useEffect(() => {    
    if(stateFaqCheck == 'true'){
      const state = Payload?.state || stateCode;
      const stateArray = stateFaqList && typeof stateFaqList === 'string'  ? stateFaqList.split(',').map(state => state.trim().toLowerCase()) : [];
      let stateFaqUrl = '';
      if(stateArray.includes(state?.toLowerCase())){
        const faqStr = "faq_link_"+state?.toLowerCase()
        stateFaqUrl = genericContent?.[faqStr]??'';
      }
      setFaqUrl(stateFaqUrl);
    }else if(cignaFaqLink && cignaFaqLink !== ''){
      const faqUrl = process.env.REACT_APP_API_BASE_URL + cignaFaqLink;
      setFaqUrl(faqUrl);
    }else{
      const faqUrl = genericContent?.faq_link??'';
      setFaqUrl(faqUrl);
    } 
  }, [Payload, stateFaqCheck, stateFaqList, genericContent, cignaFaqLink]);


  return (
    <>
      {/* GPP Banner - Added by st67393 */}
      
      <div className="position-relative iq-banner" aria-label="Header Navigation Bar">
        {/* <!--Nav Start--> */}
        <nav className="nav navbar navbar-expand-lg navbar-light iq-navbar">
          <div className="container-fluid navbar-inner py-2">
            <div className="d-flex align-items-center justify-content-between w-100 d-block d-lg-none px-3 mobile-header-container">
              <img
                  src={logoSrc}
                  alt="logo"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/overview")}
                  onKeyDown={(e) =>
                    handleKeyDown(e, () => {
                      navigate("/overview");
                      handleMenu();
                    })
                  }
                  className={`mobile-logo ${isQ5Mobile ? 'q5-mobile' : ''}`}
                />
              {isQ5Mobile ? (
                <button
                  className="navbar-toggler"
                  type="button"
                  aria-label="Toggle sidebar navigation"
                  onClick={onMobileSidebarToggle}
                  onKeyDown={(e) => handleKeyDown(e, onMobileSidebarToggle)}
                  tabIndex={0}
                >
                  <span className="navbar-toggler-icon">
                    <span className="navbar-toggler-bar bar1"></span>
                    <span className="navbar-toggler-bar bar2"></span>
                    <span className="navbar-toggler-bar bar3"></span>
                  </span>
                </button>
              ) : (
                <button
                  className={`navbar-toggler ${
                    isMobileMenuOpen ? "" : "collapsed"
                  }`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded={isMobileMenuOpen ? "true" : "false"}
                  aria-label="Toggle navigation"
                  onClick={toggleMobileMenu}
                  onKeyDown={(e) => handleKeyDown(e, toggleMobileMenu)}
                  tabIndex={0}
                >
                  <span className="navbar-toggler-icon">
                    <span className="navbar-toggler-bar bar1"></span>
                    <span className="navbar-toggler-bar bar2"></span>
                    <span className="navbar-toggler-bar bar3"></span>
                  </span>
                </button>
              )}
            </div>
            
            <div className="d-none d-lg-flex align-items-center">
              <h3 className="fw-semibold mb-2">{headerName}</h3>
            </div>
            <div
              className={`collapse navbar-collapse ${
                isQ5Mobile ? "show" : (isMobileMenuOpen ? "show" : "")
              }`}
              id="navbarSupportedContent"
            >
              {Cookies.get("owningCarrier") === 'CG' && (feedbackDisplay === true || feedbackDisplay === 'true') && (
              <div className="value-feedback mb-2 navbar-nav  align-items-center navbar-list mb-lg-0">
                
                <a href={genericContent?.cigna_value_feedback_link+'?url='+window.location.href}
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-decoration-underline ms-3 anchor-text" 
                title={genericContent?.cigna_value_feedback_text?.replace(/^\[\+\]\s*/, '')} 
                data-tooltip={genericContent?.cigna_value_feedback_text?.replace(/^\[\+\]\s*/, '')} 
                data-tooltip-my="top right" 
                data-tooltip-at="bottom center">
                  {genericContent?.cigna_value_feedback_text}</a>
              </div>
            )}
               <select
                                  id="language"
                                  className="navbar-nav mb-2 mb-lg-0 float-end me-4 mt-1 login-dropdown"
                                  value={currentLang}
                                  onChange={(e) => {
                                  handleLanguage(e);
                                  
                                }}
                                  
                                >
                                  <option value="eng" className="en-flag">
                                  {genericContent?.language_option_english}
                                  </option>
                                  <option value="spa" className="es-flag">
                                  {genericContent?.language_option_spanish}
                                  </option>
                                </select>
 
              <ul className="mb-2 navbar-nav  align-items-center navbar-list mb-lg-0">
                
                <li className="nav-item dropdown me-2" ref={dropdownRef}>
                  <a
                    className={`py-0 nav-link align-items-center avatar-50 ${Payload?.profile ? '' : 'removebackground'}`}
                    id="navbarDropdown"
                    role="button"
                    aria-expanded={isDropdownOpen}
                    onClick={toggleDropdown}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggleDropdown();
                      } else if (e.key === "ArrowDown" && isDropdownOpen) {
                        e.preventDefault();
                        // Focus on first menu item when dropdown is open
                        const firstMenuItem =
                          dropdownRef.current.querySelector(".dropdown-item");
                        if (firstMenuItem) firstMenuItem.focus();
                      } else if (e.key === "Escape" && isDropdownOpen) {
                        e.preventDefault();
                        setIsDropdownOpen(false);
                      }
                    }}
                    tabIndex={0}
                    aria-haspopup="true"
                    aria-controls="payload-dropdown-menu"
                  >
                    {Payload ? Payload?.profile : profileSrc?<img src={profileSrc} alt="Profile" className="apply hover background  profile-placeholder addMargin" /> : ''}
                  </a>
                  <ul
                    className={`dropdown-menu dropdown-menu-end ${
                      isDropdownOpen ? "show" : ""
                    }`}
                    aria-labelledby="navbarDropdown"
                    id="payload-dropdown-menu"
                    role="menu"
                  >
                    {Payload && Payload?.profile ? (
                      <li role="none">
                        <a
                          className="dropdown-item"
                          onClick={handleAccountSettings}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleAccountSettings();
                            } else if (e.key === "ArrowDown") {
                              e.preventDefault();
                              // Focus on next item
                              const nextItem =
                                e.target.parentElement.nextElementSibling?.querySelector(
                                  ".dropdown-item"
                                );
                              if (nextItem) nextItem.focus();
                            } else if (e.key === "ArrowUp") {
                              e.preventDefault();
                              // Focus on previous item or toggle button
                              const prevItem =
                                e.target.parentElement.previousElementSibling?.querySelector(
                                  ".dropdown-item"
                                );
                              if (prevItem) {
                                prevItem.focus();
                              } else {
                                setIsDropdownOpen(false);
                                const toggleButton =
                                  dropdownRef.current.querySelector(
                                    ".nav-link"
                                  );
                                if (toggleButton) toggleButton.focus();
                              }
                            } else if (e.key === "Escape") {
                              e.preventDefault();
                              setIsDropdownOpen(false);
                              const toggleButton =
                                dropdownRef.current.querySelector(".nav-link");
                              if (toggleButton) toggleButton.focus();
                            } else if (e.key === "Tab" && !e.shiftKey) {
                              // Allow normal tab navigation
                            } else if (e.key === "Tab" && e.shiftKey) {
                              e.preventDefault();
                              setIsDropdownOpen(false);
                              const toggleButton =
                                dropdownRef.current.querySelector(".nav-link");
                              if (toggleButton) toggleButton.focus();
                            }
                          }}
                          role="menuitem"
                          tabIndex={isDropdownOpen ? 0 : -1}
                        >
                          <i className="fe fe-user grey-icons ms-2 me-2 fe-18"></i>{" "}
                          {genericContent?.header_account_settings_menu}
                        </a>
                      </li>
                    ) : null}
                    <li role="none">
                      <a
                        className="dropdown-item"
                        onClick={handleLogout}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            handleLogout();
                          } else if (e.key === "ArrowDown") {
                            e.preventDefault();
                            // Focus on next item (none, so close dropdown and focus on next element)
                            setIsDropdownOpen(false);
                          } else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            // Focus on previous item
                            const prevItem =
                              e.target.parentElement.previousElementSibling?.querySelector(
                                ".dropdown-item"
                              );
                            if (prevItem) {
                              prevItem.focus();
                            } else {
                              // No previous item, focus on toggle button
                              setIsDropdownOpen(false);
                              const toggleButton =
                                dropdownRef.current.querySelector(".nav-link");
                              if (toggleButton) toggleButton.focus();
                            }
                          } else if (e.key === "Escape") {
                            e.preventDefault();
                            setIsDropdownOpen(false);
                            const toggleButton =
                              dropdownRef.current.querySelector(".nav-link");
                            if (toggleButton) toggleButton.focus();
                          } else if (e.key === "Tab" && !e.shiftKey) {
                            // Allow normal tab navigation, close dropdown
                            setIsDropdownOpen(false);
                          } else if (e.key === "Tab" && e.shiftKey) {
                            e.preventDefault();
                            // Focus on previous item
                            const prevItem =
                              e.target.parentElement.previousElementSibling?.querySelector(
                                ".dropdown-item"
                              );
                            if (prevItem) {
                              prevItem.focus();
                            } else {
                              // No previous item, close dropdown and focus on toggle button
                              setIsDropdownOpen(false);
                              const toggleButton =
                                dropdownRef.current.querySelector(".nav-link");
                              if (toggleButton) toggleButton.focus();
                            }
                          }
                        }}
                        role="menuitem"
                        tabIndex={isDropdownOpen ? 0 : -1}
                      >
                        <i className="fe fe-log-out grey-icons ms-2 me-2 fe-18"></i>{" "}
                        {genericContent?.header_logout_menu}
                      </a>
                    </li>
                  </ul>
                </li>
                {/* Hide menu icon for Q5 carrier */}
                {!isQ5Carrier  &&  (
                  <li className="nav-item dropdown me-1" style={{ zIndex: "9" }}>
                    <button
                      onClick={handleMenu}
                      style={{ border: "none", backgroundColor: "#FAFAFA" }}
                      onKeyDown={(e) => handleKeyDown(e, handleMenu)}
                      aria-label="Open menu"
                      tabIndex={0}
                    >
                      <img src={MenuIcon} alt="Menu-Icon" />
                    </button>
                  </li>
                )}
              </ul>

              <ul
                ref={menuContainerRef}
                id="sidebar-menus"
                className={`menu-container ${menuToggle ? "open" : ""}`}
              >
                  <img
                    src={logoSrc}
                    alt="logo"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigate("/overview");
                      handleMenu();
                    }}
                    onKeyDown={(e) =>
                      handleKeyDown(e, () => {
                        navigate("/overview");
                        handleMenu();
                      })
                    }
                    className="overviewnavigate"
                    tabIndex={menuToggle ? 0 : -1}
                  />
                  <a
                    className="text-decoration-none"
                    onClick={() => {
                      navigate("/limitedproficiency");
                      handleMenu();
                    }}
                    onKeyDown={(e) =>
                      handleKeyDown(e, () => {
                        navigate("/limitedproficiency");
                        handleMenu();
                      })
                    }
                    tabIndex={menuToggle ? 0 : -1}
                  >
                    <li className="limitedtab">
                      {genericContent?.footer_limited_eng_prof_menu}
                    </li>
                  </a>
                  <a
                    className="text-decoration-none"
                    onClick={() => {
                      navigate("/nondiscrimination");
                      handleMenu();
                    }}
                    onKeyDown={(e) =>
                      handleKeyDown(e, () => {
                        navigate("/nondiscrimination");
                        handleMenu();
                      })
                    }
                    tabIndex={menuToggle ? 0 : -1}
                  >
                    <li>{genericContent?.footer_non_disc_menu}</li>
                  </a>
                  
                  <a
                  className="text-decoration-none"
                  onClick={() => {
                    isConnectiCareCarrier === 'true' ? window.open('https://www.connecticare.com/contact', '_blank', 'noopener,noreferrer') : navigate("/contactus");
                    handleMenu();
                  }}
                  onKeyDown={(e) =>
                    handleKeyDown(e, () => {
                      isConnectiCareCarrier === 'true' ? window.open('https://www.connecticare.com/contact', '_blank', 'noopener,noreferrer') : navigate("/contactus");
                      handleMenu();
                    })
                  }
                  tabIndex={menuToggle ? 0 : -1}
                >
                    <li>{genericContent?.layout_contact_us_page_title}</li>
                  </a>
                  
                  <a
                    className="text-decoration-none"
                    onClick={() => {
                     faqUrl ? window.open(faqUrl, '_blank', 'noopener,noreferrer') : navigate("/faq");
                      handleMenu();
                    }}
                    onKeyDown={(e) =>
                      handleKeyDown(e, () => {
                        faqUrl ? window.open(faqUrl, '_blank', 'noopener,noreferrer') : navigate("/faq");
                        handleMenu();
                      })
                    }
                    tabIndex={menuToggle ? 0 : -1}
                  >
                    <li>{genericContent?.layout_faq_page_title}</li>
                  </a>
                  <a
                    className="text-decoration-none"
                    onClick={() => {
                      navigate("/glossary");
                      handleMenu();
                    }}
                    onKeyDown={(e) =>
                      handleKeyDown(e, () => {
                        navigate("/glossary");
                        handleMenu();
                      })
                    }
                    tabIndex={menuToggle ? 0 : -1}
                  >
                    <li>{genericContent?.footer_glossary_menu}</li>
                  </a>
                  {privacyLink !== '' && (
                    <a
                      className="text-decoration-none"
                       onClick={(e) => {
                          e.preventDefault();
                          window.open(privacyLink, '_blank', 'noopener,noreferrer'); 
                          handleMenu();
                      }}
                      onKeyDown={(e) =>
                        handleKeyDown(e, () => {
                          window.open(privacyLink, '_blank', 'noopener,noreferrer'); 
                          handleMenu();
                        })
                      }
                      tabIndex={menuToggle ? 0 : -1}
                    >
                      <li>{genericContent?.footer_privacy_menu}</li>
                    </a>
                  )}
                </ul>
            </div>
          </div>
        </nav>
        {/* GPP Banner positioned below navbar */}
        <GPPBanner />
      </div>
    </>
  );
};

export default Header;
